/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-array-index-key */
import { useRef, useState } from 'react';
import { icons } from '~/assets';
import Button from '~/components/button';
import Collapse from '~/components/collapse';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import RadioButton from '~/components/radioButton';
import * as Actions from '../Establishment/actions';
import BankData from './components/BankData';
import GeneralAgreementData from './components/GeneralAgreementData';
import GeneralData from './components/GeneralData';
import MDRData from './components/MDRData';
import * as St from './styles';
const dialogInitialState = { open: false, message: '' };

const PARTNERSHIP_ALLOWED_CHANGES: Record<string, string[]> = {
  COMMERCIAL: ['COMMERCIAL', 'ALL'],
  AGREEMENT: ['AGREEMENT', 'ALL'],
  ALL: [],
};

const isPartnershipOptionDisabled = (
  initialPartnership: string,
  option: string,
): boolean => {
  const allowed = PARTNERSHIP_ALLOWED_CHANGES[initialPartnership] ?? [];
  return !allowed.includes(option);
};

export default function ParametersData({
  parameters = null,
}: {
  parameters: unknown;
}) {
  const [form, setForm] = useState(parameters);
  const [dialog, setDialog] = useState(dialogInitialState);
  const generalAgreementRef = useRef();
  const handleUpdateCompany = async (payload) => {
    try {
      const response = await Actions.handleUpdateCompany(
        payload,
        parameters.id,
      );

      setDialog({
        open: true,
        message: response.data.mensagem ?? response.data.message,
      });
      return response;
    } catch (error) {
      setDialog({ open: true, message: error?.mensagem });
    }
  };
  console.log(form);

  const hasAgreementPartnership = () => {
    const partnership = form?.partnership;
    return partnership === 'AGREEMENT' || partnership === 'ALL';
  };

  const hasCommercialPartnership = () => {
    const partnership = form?.partnership;
    return partnership === 'COMMERCIAL' || partnership === 'ALL';
  };

  const getCollapseHeight = () => {
    const baseHeight = 68;
    const additionalHeight =
      2 * (form?.generalParametersAgreement?.invoiceEmails?.length || 0);
    return baseHeight + additionalHeight;
  };

  return (
    <St.BoxCard>
      <Dialog
        open={dialog.open}
        icon={icons.exclamation}
        positiveAction={() => {
          setDialog(dialogInitialState);
        }}
        message={dialog.message}
        positiveLabel="Entendi"
      />
      <Collapse
        collapseHeight={getCollapseHeight()}
        initialState="open"
        title="1. Gerais"
        key={form?.partnership}
      >
        <ContainerFlex>
          <ContainerFlex marginTop={20} marginBottom={5}>
            <h3>Tipo de parceiro</h3>
          </ContainerFlex>

          <ContainerFlex
            marginTop={10}
            row
            align="center"
            style={{ gap: '24px' }}
          >
            <label style={isPartnershipOptionDisabled(parameters?.partnership, 'COMMERCIAL') ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}>
              <ContainerFlex row horizontal align="center">
                <RadioButton
                  name="partnership"
                  value="COMMERCIAL"
                  onChange={() => {
                    setForm((prev) => ({ ...prev, partnership: 'COMMERCIAL' }));
                  }}
                  checked={form?.partnership === 'COMMERCIAL'}
                  disabled={isPartnershipOptionDisabled(parameters?.partnership, 'COMMERCIAL')}
                />
                Comercial
              </ContainerFlex>
            </label>

            <label style={isPartnershipOptionDisabled(parameters?.partnership, 'AGREEMENT') ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}>
              <ContainerFlex row horizontal align="center">
                <RadioButton
                  name="partnership"
                  value="AGREEMENT"
                  onChange={() =>
                    setForm((prev) => ({ ...prev, partnership: 'AGREEMENT' }))
                  }
                  checked={form?.partnership === 'AGREEMENT'}
                  disabled={isPartnershipOptionDisabled(parameters?.partnership, 'AGREEMENT')}
                />
                Convênio
              </ContainerFlex>
            </label>

            <label style={isPartnershipOptionDisabled(parameters?.partnership, 'ALL') ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}>
              <ContainerFlex row horizontal align="center">
                <RadioButton
                  value="ALL"
                  name="partnership"
                  checked={form?.partnership === 'ALL'}
                  onChange={() =>
                    setForm((prev) => ({ ...prev, partnership: 'ALL' }))
                  }
                  disabled={isPartnershipOptionDisabled(parameters?.partnership, 'ALL')}
                />
                Todos
              </ContainerFlex>
            </label>
          </ContainerFlex>
          <div style={{ position: 'relative' }}></div>
        </ContainerFlex>

        {hasCommercialPartnership() ? (
          <ContainerFlex marginTop={30} marginBottom={0}>
            <ContainerFlex>
              <h3>Comercial</h3>
            </ContainerFlex>
            <GeneralData
              onChange={(e) =>
                setForm((prev) => ({ ...prev, generalParametersData: e }))
              }
              defaultValues={form.generalParametersData}
            />
          </ContainerFlex>
        ) : null}

        {hasAgreementPartnership() ? (
          <ContainerFlex marginTop={30} marginBottom={0}>
            <ContainerFlex>
              <h3>Convênio</h3>
            </ContainerFlex>
            <GeneralAgreementData
              ref={generalAgreementRef}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, generalParametersAgreement: e }))
              }
              defaultValues={form?.generalParametersAgreement}
            />
          </ContainerFlex>
        ) : null}

        <ContainerFlex end row gap="30">
          <Button
            fitContent
            onClick={() => {
              if (!generalAgreementRef?.current?.handleErrors()) {
                handleUpdateCompany({
                  companyData: {
                    partnership: form.partnership,
                    generalParametersData: form.generalParametersData || {},

                    generalParametersAgreement:
                      hasAgreementPartnership() && form.generalParametersAgreement
                        ? {
                            invoiceDueDay:
                              form.generalParametersAgreement?.invoiceDueDay?.masked?.padStart(
                                2,
                                '0',
                              ) || '',
                            invoiceEmails: Array.isArray(
                              form.generalParametersAgreement?.invoiceEmails,
                            )
                              ? form.generalParametersAgreement?.invoiceEmails.map(
                                  (i) => i.value,
                                )
                              : [],
                          }
                        : {},
                  },
                });
              }
            }}
          >
            Gravar
          </Button>
        </ContainerFlex>
      </Collapse>

      {hasCommercialPartnership() ? (
        <ContainerFlex>
          <Collapse
            collapseHeight={70}
            initialState="close"
            title="2. Domicilio bancário"
          >
            <BankData
              onChange={(e) => setForm((prev) => ({ ...prev, bankData: e }))}
              defaultValues={form.bankData}
            />
            <ContainerFlex end row gap="30">
              <Button
                fitContent
                onClick={() =>
                  handleUpdateCompany({
                    bankData: [
                      {
                        ...form.bankData,
                        accountHolder: {
                          ...form.bankData?.accountHolder,
                          cpfCnpj:
                            form.bankData.accountHolder?.cpfCnpj?.unmasked,
                        },
                        type: 'CHECKING',
                      },
                    ],
                  })
                }
              >
                Gravar
              </Button>
            </ContainerFlex>
          </Collapse>
          <Collapse
            collapseHeight={70}
            initialState="close"
            title="3. Taxa de administração (MDR)"
          >
            <MDRData
              onChange={(e) =>
                setForm((prev) => ({ ...prev, splitsModalities: e }))
              }
              defaultValues={parameters.splitsModalities}
            />
            <ContainerFlex end row gap="30">
              <Button
                fitContent
                onClick={() =>
                  handleUpdateCompany({
                    companyData: {
                      splitsModalities: form.splitsModalities?.map((e) => ({
                        modality: e.modality,
                        percentualSplit: e.percentualSplit,
                      })),
                    },
                  })
                }
              >
                Gravar
              </Button>
            </ContainerFlex>
          </Collapse>
        </ContainerFlex>
      ) : null}
    </St.BoxCard>
  );
}
